import { toast,Slide } from 'react-toastify';

const showErrorToast = (title) => {
    toast.error(title, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Slide,
    });
};
 
export const showInfoToast = (title) => {
    toast.info(title, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Slide,
    });
};

export const showSuccessToast = (title) => {
    toast.success(title, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "light",
        transition: Slide,
    });
};


export default showErrorToast;
 